import { Button } from "@material-ui/core";
import { ReactNode, useState } from "react";
import { useContext } from "react";
import { AuthContext } from "../_auth/AuthContext";
import { APIPostV1 } from "../_service/http";


interface BrazeResponse {
  uuid: string,
  type: string,
  dispatchId: string,
  message: string
}

export const Braze_Page = () => {
  const { user, setUser } = useContext(AuthContext);
  const [responses, setResponses] = useState<BrazeResponse[]>([]);
  const [disabled, setDisabled] = useState<boolean>(false);

  const uuid = user.uuid;
  console.log(user);
  if (!uuid)
    return (<div>
      <hr />
      <h3>Push Notifications</h3>
      You currently do not have a Braze External Id assigned to this account.<br />
      Please log into the mobile app to establish this id, then log back into this website.
    </div>)

  const url = `https://dashboard-06.braze.com/users/user_search/user-search/5fa427ef2213590ceef6888f?locale=en&query=${uuid}`;

  const sendPushNotification = async (type: string) => {
    setDisabled(true);
    

    let response = await APIPostV1<any>({
      authorize: true,
      endpoint: '/1/utility/brazePushNotificationTest',
      method: 'POST'
    }, {
      "uuid": uuid,
      "type": type
    });

    if (response && response.success) {
      const push: BrazeResponse[] = [... responses, {
        uuid: uuid || '',
        type: type,
        dispatchId: response.success.braze.dispatch_id,
        message: response.success.braze.message
      }];
      setResponses(push);
    } else {
      const push: BrazeResponse[] = [...responses, {
        uuid: uuid || '',
        type: type,
        dispatchId: 'N/A',
        message: 'EverWash API Error.'
      }];
    }

    setDisabled(false);
  }
  
  const pushResponses :ReactNode[] = responses.map(response => {
    return (
      <tr>
        <td style={{ paddingRight: 10 }}>{response.type}</td>
        <td style={{ paddingRight: 10 }}>{response.dispatchId}</td>
        <td>{response.message}</td>
      </tr>
    );
  })

  return (<div>
    <hr/>
    <h3>Push Notifications</h3>
    <div>
      External Braze Id: <a href={url} target="_blank">{uuid}</a><br />
      <p>Before clicking one of these buttons, make sure that you have followed these steps.
        <ol>
          <li>Logged out of the mobile app.</li>
          <li>Logged out of this web site.</li>
          <li>Logged back into the mobile app first.</li>
          <li>Logged back into this website using the same account used to log into the mobile app.</li>
        </ol>
      </p>
      <Button style={{ marginTop: 10 }} variant="contained" disabled={disabled} color="primary" onClick={n => sendPushNotification('apple')}>Send iOS Push Notification</Button><br/>
      <Button style={{ marginTop: 10 }} variant="contained" disabled={disabled} color="primary" onClick={n => sendPushNotification('android')}>Send Android Push Notification</Button>

      <table style={{marginTop:20}}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left' }}>Type</th>
            <th style={{ textAlign: 'left' }}>Braze Dispatch Id</th>
            <th style={{ textAlign: 'left' }}>Message</th>
          </tr>
        </thead>

        <tbody>
          {pushResponses}
        </tbody>
      </table>

      <p>
        Please note, a success message doesn't necessarily mean that you will receive a push notification.<br />
        It simply means that Braze was successful in dispatching the push notification request to the appropriate push server.<br />
        If you are not receiving push notifications, and have followed the steps above, then please reach out to the EverWash IT to help troubleshoot.
      </p>
    </div>


  </div>)
}